import React from 'react';

import type { TransactionType } from 'types/api/transaction';

import Tag from 'ui/shared/chakra/Tag';

export interface Props {
  types: Array<TransactionType>;
  isLoading?: boolean;
}

const TYPES_ORDER: Array<TransactionType> = [
  'blob_transaction',
  'rootstock_remasc',
  'rootstock_bridge',
  'token_creation',
  'contract_creation',
  'token_transfer',
  'contract_call',
  'coin_transfer',
];

const TxType = ({ types, isLoading }: Props) => {
  const typeToShow = types.sort((t1, t2) => TYPES_ORDER.indexOf(t1) - TYPES_ORDER.indexOf(t2))[0];

  let label;
  // let colorScheme;

  switch (typeToShow) {
    case 'contract_call':
      label = 'Contract call';
      // colorScheme = 'black';
      break;
    case 'blob_transaction':
      label = 'Blob txn';
      // colorScheme = 'black';
      break;
    case 'contract_creation':
      label = 'Contract creation';
      // colorScheme = 'black';
      break;
    case 'token_transfer':
      label = 'Token transfer';
      // colorScheme = 'black';
      break;
    case 'token_creation':
      label = 'Token creation';
      // colorScheme = 'black';
      break;
    case 'coin_transfer':
      label = 'Coin transfer';
      // colorScheme = 'black';
      break;
    case 'rootstock_remasc':
      label = 'REMASC';
      // colorScheme = 'black';
      break;
    case 'rootstock_bridge':
      label = 'Bridge';
      // colorScheme = 'black';
      break;
    default:
      label = 'Transaction';
      // colorScheme = 'black';

  }

  return (
    <Tag color="#D1102B" bgColor="rgba(209,16,43,0.08)" padding="2px 12px 2px 12px" isLoading={ isLoading }>
      { label }
    </Tag>
  );
};

export default TxType;
